import { render } from "./ChannelOrderSuccess.vue?vue&type=template&id=61d866d3&scoped=true"
import script from "./ChannelOrderSuccess.vue?vue&type=script&lang=js"
export * from "./ChannelOrderSuccess.vue?vue&type=script&lang=js"

import "./ChannelOrderSuccess.vue?vue&type=style&index=0&id=61d866d3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d866d3"]])

export default __exports__